// This file is generated automatically by scripts/generate-icon.js. Don't modify it.

import Photo from '../_raw/ui/icon_photo.svg';
import withIconProps from '../withIconProps';

export default withIconProps(Photo);
